export const PERIODS = { "1M": 1, "3M": 3, "6M": 6, "1Y": 12, "3Y": 36, "5Y": 60, ALL: 9999 };

export function filterHistory(history, period) {
  const months = PERIODS[period] ?? 9999;
  const cutoff = new Date();
  cutoff.setMonth(cutoff.getMonth() - months);
  return history.filter((h) => new Date(h.date) >= cutoff);
}

export function PeriodSelector({ period, setPeriod, testId }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {Object.keys(PERIODS).map((p) => (
        <button key={p} data-testid={`period-${p.toLowerCase()}`} onClick={() => setPeriod(p)}
          className={`text-[11px] font-semibold rounded-full px-3 py-1.5 border transition-colors duration-200 ${
            period === p ? "pill-active" : "border-white/10 text-zinc-500 hover:text-zinc-200 hover:border-white/20"
          }`}>
          {p === "ALL" ? "Since Inception" : p}
        </button>
      ))}
    </div>
  );
}

export const historyToChart = (history, period) =>
  filterHistory(history, period).map((h) => ({
    label: new Date(h.date).toLocaleDateString("en-IN", { month: "short", year: "2-digit" }),
    value: h.value,
    invested: h.invested ?? null,
  }));
